import { BACKGROUND_IMAGE_ATTRIBUTE } from '../constants/block-background-attributes';

const isBackgroundOptionChanged = (backgroundOption) => {
  if (!backgroundOption) return false;

  const { initialValues, values } = backgroundOption;

  return Object.entries(values).some(([attribute, value]) => {
    switch (attribute) {
      case BACKGROUND_IMAGE_ATTRIBUTE:
        return !initialValues[attribute].includes(value);
      default:
        return initialValues[attribute] !== value;
    }
  });
};

export default isBackgroundOptionChanged;
